export default "__VITE_ASSET__CUAciRfM__"